.container {
	min-width: 180px;
	min-height: 54px;
	border-width: 0;
	border-radius: 6px;
	align-self: center;
	margin-top: 16px;
	/* padding: 8px 4px 8px 4px; */
	background-color: #0f9b9d;
	cursor: pointer;
	transition: 0.15s;
}
.container:hover {
	background-color: #0d8486;
	transition: 0.15s;
}

.disabled {
	opacity: 0.6;
	cursor: default;
}
.disabled:hover {
	background-color: #0f9b9d;
}

.text {
	font-size: 19px;
	color: rgb(245, 245, 245);
	text-align: center;
}

@media only screen and (max-width: 860px) {
	.container {
		width: 132px;
		min-width: 132px;

		min-height: 50px; /* add this */
		margin-top: 12px;
		/* padding: 12px 0 12px 0; */
		padding: 0 4px;
	}
	.text {
		font-size: 18px;
	}
}

.loader {
	width: 16px;
	height: 16px;
	border: 2px solid rgba(255, 255, 255, 0.3);
	border-top: 2px solid white;
	border-radius: 50%;
	animation: spin 0.7s linear infinite;
	margin: auto;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}
